import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the auth instance
export const firebaseAuth = getAuth(app);

// ✅ Enable Firebase auth persistence (survives page refresh)
setPersistence(firebaseAuth, browserLocalPersistence)
  .then(() => {
    console.log('✅ Firebase persistence enabled');
  })
  .catch((error) => {
    console.error('❌ Firebase persistence error:', error);
  });


// Optional: export app if you need other Firebase services later
export default app;